import ApiService from '../api.service';

const ReoffersResource = {
  create: (params) => ApiService.post(`/v1/business/${params.business_id}/credit_offereds/${params.credit_offered_id}/reoffers`, params.offers_payload),
  index: (params) => ApiService.get(`/v1/business/${params.business_id}/credit_offereds/${params.credit_offered_id}/reoffers`),
};

export default ReoffersResource;
